import { Button, Modal } from "@arco-design/web-react";
import { useBudgetConfirmationImport } from "../runtime/useBudgetConfirmationImport";
import type { BudgetConfirmationImportOptions } from "../runtime/useBudgetConfirmationImport";

/** 当前已保存核价的一次性导入入口，已有数据必须先明确确认覆盖。 */
export function QuoteBudgetImportButton(props: BudgetConfirmationImportOptions) {
  const state = useBudgetConfirmationImport(props);
  return <>
    <Button disabled={props.blocked} loading={state.pending} title={props.blocked ? "请先保存核价并完成当前操作" : "将当前已保存核价导入确认件，住宿不导入"} onClick={() => void state.start()}>导入确认件</Button>
    {state.error ? <span role="alert">{state.error}</span> : null}
    <Modal title="覆盖当前确认件？" visible={Boolean(state.preview)} onCancel={state.cancel} onOk={() => void state.confirm()} okText="确认覆盖并导入" cancelText="取消" confirmLoading={state.pending} closable={!state.pending} maskClosable={false} okButtonProps={{ status: "warning", disabled: props.blocked }} cancelButtonProps={{ disabled: state.pending }}>
      <p>将使用核价 V{state.preview?.version_no}「{state.preview?.version_name}」替换当前确认件全部 {state.preview?.existing_line_count} 条明细，包括手工录入和修改的内容。</p>
      <p>住宿不导入；其他费用尽量转换，无法转换的项目会逐项提示。导入后请核对服务、主体及金额。</p>
    </Modal>
    {state.result && !state.result.applied ? <details open><summary>没有可转换的费用，原确认件未改动</summary><ul>{state.result.report.issues.map(issue => <li key={issue.source_line_id}>第 {issue.line_no} 行 · {issue.name}：{issue.reason}</li>)}</ul></details> : null}
  </>;
}
